import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import { ArrowForward } from '../../../Icons';
var DesktopFlightModalHeader = function (_a) {
    var className = _a.className, title = _a.title, onClose = _a.onClose;
    var css = useTheme('DesktopFlight').DesktopFlightModalHeader;
    var t = useTranslation('FlightInfoModalContent').t;
    return (React.createElement("div", { className: cn(css.container, className) },
        React.createElement("div", { className: css.wrapper },
            React.createElement("div", { className: css.arrow, onClick: onClose }, ArrowForward),
            React.createElement("div", { className: css.title }, title),
            React.createElement("div", { className: css.close, onClick: onClose },
                React.createElement("span", null, t('Back')),
                React.createElement("div", { className: css.close__icon })))));
};
export default DesktopFlightModalHeader;
